import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { toast } from 'react-toastify';

var ToastService =
/*#__PURE__*/
function () {
  function ToastService() {
    _classCallCheck(this, ToastService);
  }

  _createClass(ToastService, [{
    key: "showInfo",
    value: function showInfo(text) {
      toast.info(text);
    }
  }, {
    key: "showWarning",
    value: function showWarning(text) {
      toast.warn(text);
    }
  }, {
    key: "showSuccess",
    value: function showSuccess(text) {
      toast.success(text);
    }
  }]);

  return ToastService;
}();

export default new ToastService();